import type { LoggerPort } from '@omnea-app/packages/universal/general/observability/LoggerPort'

export function assertNever(input: never, logger: LoggerPort = console): null {
  logger.error('Unexpected function call', { inputType: typeof input })
  return null
}
